import { Form, Errors } from "vform";

export default {
    install(app) {
        // Provide Form and Errors globally
        app.config.globalProperties.$form = Form;
        app.config.globalProperties.$errors = Errors;

        // Optionally, you can also make it available using Vue's provide/inject API
        // app.use("Form", Form);
        // app.use("Errors", Errors);
    },
};
